module.exports = __webpack_public_path__ + "static/img/success-bg.cde9d359.png";